import React, { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import dayjs from "dayjs";
import http from "services/http";
import formatMoney from "utils/formatMoney";
import { alerta } from "components/Alert/index";
import BilheteBilhetinho from "components/BilheteBilhetinho";

export default function BilhetinhoBilhetes() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [apostas, setApostas] = useState([]);
  const [apostaModal, setApostaModal] = useState(null);

  const buscarApostas = async () => {
    try {
      setLoading(true);
      const { data: { data } } = await http.get('/bilhetinho/apostas', {
        params: { dois_quinhentos_id: id, situacao: 'todos' }
      });
      setApostas(data);
    } catch (e) {
      alerta(e.response?.data ?? { message: 'Erro ao listar bilhetes!' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarApostas();
  }, [id]);

  return (
    <>
      <div className="titulo-principal d-flex justify-content-between align-items-center">
        <span>Bilhetes da extração</span>
        <NavLink exact className="btn btn-light" to={{ pathname: '/bilhetinho' }}>
          Voltar
        </NavLink>
      </div>

      <div className="conteudo-principal p-0 mt-2">
        <table className="table text-left border text-center">
          <thead>
            <tr>
              <th>Código</th>
              <th>Operador</th>
              <th>Data</th>
              <th>Situação</th>
              <th>Valor</th>
              <th>Prêmio</th>
              <th>Ver</th>
            </tr>
          </thead>
          <tbody>
            {!loading && apostas.length === 0 && (
              <tr>
                <td colSpan={7}>Nenhum bilhete encontrado.</td>
              </tr>
            )}
            {apostas.map((aposta) => (
              <tr key={aposta.codigo}>
                <td>{aposta.codigo}</td>
                <td>{aposta.operador}</td>
                <td>{aposta.data_aposta ? dayjs(aposta.data_aposta).format('DD/MM/YYYY HH:mm') : '—'}</td>
                <td>
                  <span className={`badge ${aposta.situacao}`}>{aposta.situacao}</span>
                </td>
                <td>{formatMoney(aposta.valor)}</td>
                <td>{formatMoney(aposta.premio ?? 0)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-info w-100 px-0"
                    onClick={() => setApostaModal(aposta)}
                  >
                    Ver
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {apostaModal && (
        <div
          className="modal"
          style={{ display: 'block', overflowY: 'scroll', maxHeight: '100%' }}
          onClick={() => setApostaModal(null)}
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content modal-bilhete">
              <div className="modal-body">
                {apostaModal.ip && (
                  <div className="alert alert-light border text-center p-2 mb-2" style={{ fontSize: '13px' }}>
                    <strong>IP do bilhete:</strong> {apostaModal.ip}
                  </div>
                )}
                <BilheteBilhetinho aposta={apostaModal} />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setApostaModal(null)}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
